import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FeeService } from '@app/services/fees/fee.service';
import { Validators, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SnackbarService } from '@app/services/shared/snackbar.service';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface YearFee {
  year: number;
  fee: number;
}

@Component({
  selector: 'app-handlefees',
  templateUrl: './handlefees.component.html'
})

export class HandlefeesComponent implements OnInit, OnDestroy {
  @Input() institution: LodgeAndCamp;
  @Input() year: number;
  feelist: YearFee[] = [];
  subscriptions: Subscription[] = [];
  editfee = false;
  action = 'add';
  savelabel = 'Spara';
  feeform;
  

  constructor(
    private feeService: FeeService,
    private fb: FormBuilder,
    private snackBarService: SnackbarService) { }

  ngOnInit() {
    this.feeform = this.fb.group({
      year: ['', Validators.required],
      fee: ['', Validators.required]
    });
    this.subscriptions.push(this.feeService.getFees(this.institution.id).subscribe(response => {
      this.feelist = response;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  saveFee() {
    if (this.editfee) {
      this.action = 'update';
    }
    const feedata = {
      institutionId: this.institution.id,
      year: this.feeform.get('year').value,
      ammount: this.feeform.get('fee').value,
      action: this.action
    };

    this.subscriptions.push(this.feeService.addFee(feedata).subscribe(response => {
      if (response) {
        if (this.action === 'add') {
          this.snackBarService.openSnackBar('Medlemsavgift för ' + feedata.year + ' inlagt.', null);
        } else {
          this.snackBarService.openSnackBar('Medlemsavgift för ' + feedata.year + ' uppdaterad.', null);
        }
        this.action = 'add';
        this.savelabel = 'Spara';
        this.feeform.reset();
        this.ngOnInit();
      }
    }));
  }

  editFee(fee) {
    this.editfee = true;
    this.savelabel = 'Spara ändring';
    this.feeform.patchValue(fee);
  }

  cancel() {
    this.feeform.reset();
    this.savelabel = 'Spara';
  }
}
